<div class="zbp-number-input-container theme-{{theme}}"
     [class.is-invalid]="invalid"
    (mouseleave)="closeTip()">
  <button *ngIf="!readonly"
          id="{{uniqueId}}_subtract-button"
          class="subtract-button"
          [class.disabled]="isSubtractDisabled"
          (click)="onSubtractButtonClick()"
          [ngbTooltip]="subtractTooltip"
          #tip="ngbTooltip"
          triggers="mouseenter:mouseleave focus:blur"
          [autoClose]="false"
          (mouseenter)="showTip(tip)"
          [attr.aria-disabled]="isSubtractDisabled"
          [attr.aria-label]="minusButtonAriaLabel"
          aria-live="polite"
          type="button">
    <span>-</span>
  </button>
  <div *ngIf="Boolean(innerFormControl)"
       class="counter-container"
       [attr.aria-live]="ariaLiveCounterState">
    <input #counter
           id="{{uniqueId}}"
           type="number"
           [attr.aria-label]="counterAriaLabel"
           class="counter-styles counter-width"
           [formControl]="innerFormControl"
           (input)="onInputChange()"
           [readOnly]="readonly"
           [placeholder]="placeholder"
           (blur)="onBlur()"
           (wheel)="onScroll($event)"
    />
    <span #calc
          id="{{uniqueId}}_counter-calc"
          class="counter-calc"
    ></span>
    <div *ngIf="showMax">
      / {{ maxValue }}
    </div>
  </div>
  <button *ngIf="!readonly"
          id="{{uniqueId}}_add-button"
          class="add-button"
          (click)="onAddButtonClick()"
          [class.disabled]="isAddDisabled"
          [attr.aria-disabled]="isAddDisabled"
          [attr.aria-label]="addButtonAriaLabel"
          #tip="ngbTooltip"
          triggers="mouseenter:mouseleave focus:blur"
          [ngbTooltip]="addTooltip"
          aria-live="polite"
          type="button">
    <span>+</span>
  </button>
</div>
